import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    line1: { type: String, required: false },
    line1MaskHeight: { type: Number, default: 100 },
    line1Indent: { type: Number, default: 0 },
    line2: { type: String, required: false },
    line2MaskHeight: { type: Number, default: 100 },
    line2Indent: { type: Number, default: 0 },
    line3: { type: String, required: false },
    line3MaskHeight: { type: Number, default: 100 },
    line3Indent: { type: Number, default: 0 },
    line4: { type: String, required: false },
    line4MaskHeight: { type: Number, default: 100 },
    line4Indent: { type: Number, default: 0 },
    loadedInStorybook: { type: Boolean, default: false },
  },
});
